export default __webpack_public_path__ + "static/media/skill5.8fcad080.svg";